import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../components/icons/Icon';
import {
    DateStringFormatOptions,
    FormatOptions,
    TimeStringFormatOptions,
} from '../../../../common/table/CellTypeConstants';
import Checkbox from '../../../components/Checkbox';
import { getFormattedDate, getFormattedTime } from '../../../../common/table/utils/tableCellFormattingUtils';
import SelectInput from '../../../components/select/SelectInput';

import { useTranslator } from '../../../components/i18n/useTranslator';

const DateFormatOptions = (props) => {
    const { sharedFormattingValues, updateCellTypeFormat, locale } = props;
    const { dateFormat, timeFormat, timeInBrackets } = sharedFormattingValues;
    const translate = useTranslator('popup', 'table.format');

    // Milanote's birthday!
    const exampleDate = new Date('February 29, 2016 13:24:56');

    const timeOnlyDisplayed = dateFormat === DateStringFormatOptions.NONE;
    const dateOnlyDisplayed = timeFormat === TimeStringFormatOptions.NONE;

    return (
        <>
            <div className="DateFormatOptions celltype-format-section">
                <div className="celltype-format-title">
                    {translate('dateFormat', 'Date format:')}
                </div>
                <div className="celltype-format-inputs">
                    <div className="dropdown-container celltype-format-input">
                        <SelectInput
                            value={dateFormat}
                            onChange={(e) => updateCellTypeFormat({ [FormatOptions.DATE_FORMAT]: e.target.value })}
                            className="dropdown"
                        >
                            {Object.values(DateStringFormatOptions).map((option, i) => (
                                <option
                                    key={i}
                                    value={option}
                                    disabled={option === DateStringFormatOptions.NONE && dateOnlyDisplayed}
                                >
                                    {getFormattedDate(exampleDate, option, locale) || translate('dateNone', 'None')}
                                </option>
                            ))}
                        </SelectInput>
                        <div className="arrow-icon-container">
                            <Icon name="dropdown-arrow" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="DateFormatOptions celltype-format-section">
                <div className="celltype-format-title">
                    {translate('timeFormat', 'Time format:')}
                </div>
                <div className="celltype-format-inputs">
                    <div className="dropdown-container celltype-format-input">
                        <SelectInput
                            value={timeFormat}
                            onChange={(e) => {
                                updateCellTypeFormat({
                                    [FormatOptions.TIME_FORMAT]: e.target.value,
                                    ...(e.target.value !== TimeStringFormatOptions.NONE && {
                                        [FormatOptions.HAS_TIME]: true,
                                    }),
                                });
                            }}
                            className="dropdown"
                        >
                            {Object.values(TimeStringFormatOptions).map((option, i) => (
                                <option
                                    key={i}
                                    value={option}
                                    disabled={option === TimeStringFormatOptions.NONE && timeOnlyDisplayed}
                                >
                                    {getFormattedTime(exampleDate, option, locale) || translate('timeNone', 'None')}
                                </option>
                            ))}
                        </SelectInput>
                        <div className="arrow-icon-container">
                            <Icon name="dropdown-arrow" />
                        </div>
                    </div>
                    {timeFormat !== TimeStringFormatOptions.NONE && (
                        <div className="checkbox-input celltype-format-input">
                            <Checkbox
                                checked={timeInBrackets}
                                onClick={() =>
                                    updateCellTypeFormat({ [FormatOptions.TIME_IN_BRACKETS]: !timeInBrackets })
                                }
                            />
                            <span>
                                {translate('timeInBrackets', 'Show time in brackets')}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

DateFormatOptions.propTypes = {
    sharedFormattingValues: PropTypes.object,
    updateCellTypeFormat: PropTypes.func,
    locale: PropTypes.string,
};

export default DateFormatOptions;
